module.exports = __webpack_public_path__ + "img/logo.0cc18c1d.svg";